import * as React from 'react';
import * as _ from 'lodash';
import PagerEx from '../../components/PageLayout/PagerEx';
export default function () {
    function onChange1(e) {
        this.props.setSearchTerm(e.target.value);
    }
    function onChange2(customer, customerIndex) {
        this.props.setAssigneeChecked(customer.id);
    }
    function repeatCustomer3(customer, customerIndex) {
        return React.createElement('li', { 'key': 'customer_' + customer.id }, React.createElement('div', { 'className': 'feature-inclusion-popup-row' }, React.createElement('div', { 'className': 'ui-checkbox2' }, React.createElement('input', {
            'type': 'checkbox',
            'id': 'customer_' + customer.id,
            'checked': this.isChecked(customer.id),
            'onChange': onChange2.bind(this, customer, customerIndex)
        }), React.createElement('label', { 'htmlFor': 'customer_' + customer.id }, customer.name))));
    }
    return React.createElement('div', { 'className': 'ui-popup' }, React.createElement('div', { 'className': 'ui-popup-header' }, React.createElement('span', { 'className': 'ui-popup-header__text' }, 'Select Assignees for the Feature Preset \u201C', this.props.selectedPreset.name, '\u201D')), React.createElement('div', { 'className': 'ui-popup-body ui-popup-body--small' }, React.createElement('div', { 'className': 'feature-inclusion-popup-search' }, React.createElement('input', {
        'className': 'feature-inclusion-popup-search__input',
        'placeholder': 'Search',
        'onChange': onChange1.bind(this)
    })), React.createElement('div', { 'className': 'feature-inclusion-popup-content' }, React.createElement.apply(this, [
        'ul',
        { 'className': 'ui-list' },
        _.map(this.props.pagedCustomers, repeatCustomer3.bind(this))
    ])), this.props.totalPages > 1 ? React.createElement(PagerEx, {
        'pageCount': this.props.totalPages,
        'forcePage': this.props.page,
        'onPageChange': page => this.setPage(page),
        'key': '1124'
    }) : null), React.createElement('div', { 'className': 'ui-popup-footer' }, React.createElement('button', {
        'className': 'ui-button ui-button--blue',
        'onClick': this.props.hideAddAssigneePopup
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Cancel')), React.createElement('button', {
        'className': 'ui-button ui-button--green',
        'onClick': this.props.saveAddAssignees
    }, React.createElement('span', { 'className': 'ui-button-text ui-button--uppercase' }, 'Save'))));
}